<progress
  class="uni-audio-progress"
  [value]="audioProgress"
  max="1"
></progress>
